import { api } from "./useApi";
import {Plano} from "../types/Plano";

export const EmpresaApi = () => ({
  get_empresa_usuario: async () => {
    let res = api.post("usuario/get_empresa_usuario").then(
      (res) => {
        // Ensure res.data exists and has default values
        if (!res.data) {
          res.data = {};
        }
        
        // Initialize dominio and subdominio if they don't exist
        res.data.dominio = res.data.dominio || "";
        res.data.subdominio = res.data.subdominio || "";
        
        if (res.data.dominio != "" || res.data.subdominio != "") {
          res.data.dominio =
            res.data.dominio != "" ? res.data.dominio : res.data.subdominio;
          res.data.dominio_https = "https://" + res.data.dominio + "/";
        } else {
          // Set default domain values when both are empty
          if (window.location.hostname === 'localhost') {
            res.data.dominio = 'localhost:5173/';
            res.data.dominio_https = 'http://localhost:5173/';
          } else {
            res.data.dominio = 'app.conectavenda.com.br';
            res.data.dominio_https = 'https://app.conectavenda.com.br/';
          }
        }
        
        // Ensure dominio_https is always defined with a fallback
        if (!res.data.dominio_https) {
          res.data.dominio_https = 'https://app.conectavenda.com.br/';
        }
        
        // Handle logo_empresa
        if (res.data.logo_empresa) {
          res.data.logoEmpresa =
            res.data.logo_empresa.indexOf("https") == -1
              ? ""
              : res.data.logo_empresa;
        } else {
          res.data.logoEmpresa = "";
        }

        return res.data;
      },
      (err) => {
        console.log("err", err);
        // Return a default object on error
        return {
          dominio: 'app.conectavenda.com.br',
          dominio_https: 'https://app.conectavenda.com.br/',
          logoEmpresa: ''
        };
      },
    );
    return res;
  },

  getIntermediadores: async () => {
    let response = await api.post("/catalogo/intermediadores");
    return response.data;
  },

  verificaVersaoCatalogo: async () => {
    const res = await api.post("empresa/versao_layout_catalogo").then(
      (res) => {
        return res.data;
      },
      (err) => {
        console.log("err", err);
      },
    );
    return res;
  },

  modalTermosDeUso: async () => {
    const res = await api.post("empresa/verificaTermosUso").then(
      (res) => {
        return res.data;
      },
      (err) => {
        console.log("err", err);
      },
    );
    return res === "TERMOS_NAO_ACEITOS" ? true : false;
  },

  modalAviso: async () => {
    const res = await api.post("empresa/verificaAviso").then(
      (res) => {
        return res.data;
      },
      (err) => {
        console.log("err", err);
      },
    );
    return res;
  },

  plano_empresa: async () => {
    let res = await api.post("empresa/plano_empresa").then(
      (res) => {
        let plano: Plano = res.data[0];
        return plano;
      },
      (err) => {
        console.log("err", err);
      },
    );
    return res;
  },

  aceite_termosUso: async () => {
    const res = api.post("empresa/aceite_termosUso").then(
      (res) => {
        return res.data;
      },
      (err) => {
        console.log("%c err ", "background:#4682B4;color:white;", err);
      },
    );

    return res;
  },
  erp_empresa: async () => {
    const res = api.post("empresa/erp").then(
      (res) => {
        return res.data;
      },
      (err) => {
        console.log("%c err ", "background:#4682B4;color:white;", err);
      },
    );
    return res;
  },
  get_erp_empresa: async () => {
    const res = api.post("empresa/get_erp").then(
      (res) => {
        return res.data;
      },
      (err) => {
        console.log("%c err ", "background:#4682B4;color:white;", err);
      },
    );
    return res;
  },
  get_chave_api: async () => {
    const res = api.post("empresa/get_chave_api").then(
      (res) => {
        return res.data;
      },
      (err) => {
        console.log("%c err ", "background:#4682B4;color:white;", err);
      },
    );
    return res;
  },
  gerar_chave_api: async (
    cadastrarProdutos: boolean,
    cadastrarImagens: boolean,
    selecionarERP: string,
  ) => {
    const res = api
      .post("empresa/gerar_chave_api", { cadastrarProdutos, cadastrarImagens, selecionarERP })
      .then(
        (res) => {
          return res.data;
        },
        (err) => {
          console.log("%c err ", "background:#4682B4;color:white;", err);
        },
      );
    return res;
  },
  getStatusTokensIA: async () => {
    const res = await api.post("empresa/status_tokens_ia").then(
      (res) => {
        return res.data;
      },
      (err) => {
        console.log("Erro ao buscar status dos tokens:", err);
        return { tokens_utilizados: 0, limite_tokens: 0 };
      }
    );
    return res;
  },
  getDiasTesteGratis: async () => {
    const res = await api.post("empresa/dias_teste_gratis").then(
      (res) => {
        return res.data;
      },
      (err) => {
        console.log("Erro ao buscar os dados: ", err);
      }
    );
    return res;
  },
});
